export default __webpack_public_path__ + "static/media/PT-Root-UI_Regular.c8b6805d.woff";